import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import NoAuthHomeGDC from './NoAuthHome.GDC';
import NoAuthHomeGDG from './NoAuthHome.GDG';
import NoAuthHomeEFG from './NoAuthHome.EFG';

const NoAuthHome = () => {
  switch (portal) {
    case Portal.Gascaribe:
      return <NoAuthHomeGDC />;
    case Portal.Gasguajira:
      return <NoAuthHomeGDG />;
    case Portal.Efigas:
      return <NoAuthHomeEFG />;
    default:
      return <></>;
  }
};

export default NoAuthHome;
